import * as React from "react";
import { createStyles, Theme, withStyles, Typography } from "@material-ui/core";
import NonMobileEnrollmentSection from "../cached_pharmacy_customer_provider/components/cached-pharmacy-customer-provider/NonMobileEnrollmentSection";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(16),
      marginRight: spacing(16),
    },
    title: {
      textAlign: "center",
      marginTop: spacing(4),
      marginBottom: spacing(4),
    },
  });

const NonMobileEnrollmentCustomerProviderPage = (props: any) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Typography align='center' variant='h3' className={classes.title}>
        Non Mobile Enrollment Customers
      </Typography>
      <NonMobileEnrollmentSection />
    </div>
  );
};

export default withStyles(styles)(NonMobileEnrollmentCustomerProviderPage);
